import script from "./routerView.vue?vue&type=script&lang=ts&setup=true"
export * from "./routerView.vue?vue&type=script&lang=ts&setup=true"

import "./routerView.vue?vue&type=style&index=0&id=2b3c1be1&lang=css"

const __exports__ = script;

export default __exports__